import styled from 'styled-components';

export const ButtonIcon = styled.button`
  background-color: ${({ theme }) => theme.colors.oxfordBlue};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: ${({ theme }) => theme.radius.l};
  font: inherit;
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  height: ${({ theme }) => theme.height.h5};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s};
  padding: 0 ${({ theme }) => theme.spacing.sm};
  min-width: 115px;
`;
